export default "__VITE_ASSET__DRYl$Ai8__"